import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-business',
  templateUrl: './not-business.component.html',
  styleUrls: ['./not-business.component.scss']
})
export class NotBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
